@let adminItems = (adminItems$ | async) ?? [];

<div
    class="menu tw-max-h-[calc(100vh_-_5rem)]"
    [class.show]="open"
    [class.wrapped]="isVeryLargeFontSize$ | async"
    [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }"
    @Grow
>
    @if (!hasManyCompanies) {
        <div aria-hidden="true" class="tw-flex tw-items-center tw-gap-4 tw-mb-9">
            <ng-container *ngTemplateOutlet="userInfo"></ng-container>
        </div>
    }
    <div id="1" appList class="tw-flex tw-flex-col tw-gap-9">
        @if (hasManyCompanies) {
            <ul role="menu" class="tw-flex tw-gap-6">
                <li role="presentation" class="tw-flex tw-items-center tw-gap-4">
                    <ng-container *ngTemplateOutlet="userInfo"></ng-container>
                </li>

                <li role="none" class="tw-flex tw-items-center">
                    <button
                        appListItem
                        app-button-outline
                        severity="primary"
                        size="sm"
                        icon="alter-company"
                        iconPosition="right"
                        [text]="'v3-global-switch-account' | translate"
                        buttonDataTest="switchAccountButton"
                        (click)="goToCompanySelection()"
                        role="menuitem"
                    ></button>
                </li>
            </ul>
        }
        <div class="menu-box">
            <div class="tw-flex tw-flex-col tw-gap-10">
                @if (belowXl$ | async) {
                    <ul role="menu" [ariaLabel]="'v3-header-menu-title-header' | translate" class="header-items">
                        <li role="none" class="section-header" aria-hidden="true">{{ 'v3-header-menu-title-header' | translate }}</li>
                        @for (item of mobileHeaderItems$ | async; track item.name) {
                            <li role="none">
                                <a role="menuitem" appListItem [routerLink]="item.route" class="menu-item" (click)="close()">
                                    <app-icon class="tw-size-5" [name]="item.icon" />
                                    <span class="menu-item-text">{{ item.name | translate }}</span>
                                </a>
                            </li>
                        }

                        @for (item of headerItems$ | async; track item.url) {
                            <li role="none">
                                <a role="menuitem" appListItem linkDataTest="headerCustomItemLink" [routerLink]="item.url" class="menu-item" (click)="close()">
                                    <div>
                                        <img class="tw-size-5" [src]="item.image" alt="" />
                                    </div>
                                    <span class="menu-item-text">{{ item.name }}</span>
                                </a>
                            </li>
                        }
                    </ul>
                }

                @if (adminItems.length > 0) {
                    <ul role="menu" [ariaLabel]="'v3-header-menu-item-admin-settings' | translate" class="header-items">
                        <li role="none" class="section-header" aria-hidden="true">{{ 'v3-header-menu-item-admin-settings' | translate }}</li>
                        @for (item of adminItems; track item.name) {
                            <li role="none">
                                <a role="menuitem" class="menu-item" (click)="close()" [routerLink]="item.route" appListItem>
                                    <app-icon [name]="item.icon" class="tw-size-5" />
                                    <span class="menu-item-text">{{ item.name | translate }}</span>
                                </a>
                            </li>
                        }
                    </ul>
                }

                <ul role="menu" [ariaLabel]="'v3-header-menu-title-learning' | translate">
                    @if (canLearn) {
                        <li role="none" class="section-header" aria-hidden="true">{{ 'v3-header-menu-title-learning' | translate }}</li>

                        @for (item of learnItems$ | async; track item.name) {
                            <li role="none">
                                @switch (item.icon) {
                                    @case ('graduate-cap') {
                                        <a role="menuitem" appListItem [routerLink]="item.route" class="menu-item" (click)="close()">
                                            <app-icon class="tw-size-5" [name]="item.icon" />
                                            <div class="tw-flex tw-items-center tw-gap-3">
                                                <span class="menu-item-text">{{ item.name | translate }}</span>
                                                @if (challengesCount) {
                                                    <span class="menu-item-badge">
                                                        {{ challengesCount > 9 ? '9+' : challengesCount }}
                                                    </span>
                                                }
                                            </div>
                                        </a>
                                    }

                                    @case ('program') {
                                        <button
                                            role="menuitem"
                                            appListItem
                                            class="menu-item tw-w-full"
                                            appPathPopup
                                            type="dropdown"
                                            [isMyLearningPath]="true"
                                            linkDataTest="programLink"
                                            (click)="close()"
                                        >
                                            <app-icon class="tw-size-5" [name]="item.icon" />
                                            <span class="menu-item-text">{{ item.name | translate }}</span>
                                        </button>
                                    }

                                    @default {
                                        <a role="menuitem" appListItem [routerLink]="item.route" class="menu-item" (click)="close()">
                                            <app-icon class="tw-size-5" [name]="item.icon" />
                                            <span class="menu-item-text">{{ item.name | translate }}</span>
                                        </a>
                                    }
                                }
                            </li>
                        }
                        @for (item of dropdownItems; track $index) {
                            <li role="none">
                                <button
                                    customRole="menuitem"
                                    appExternalLinkPopup
                                    [data]="{ url: item.url }"
                                    appListItem
                                    class="menu-item tw-w-full"
                                    (click)="close()"
                                >
                                    <div class="tw-size-5">
                                        <img [src]="item.image" alt="" />
                                    </div>
                                    <span class="menu-item-text">{{ item.name | translate }}</span>
                                </button>
                            </li>
                        }
                    }
                </ul>
            </div>

            <div class="tw-flex tw-flex-col tw-gap-10">
                <ul role="menu" [ariaLabel]="'v3-dashboard-menu-whats-new' | translate">
                    <li role="none" class="section-header" aria-hidden="true">{{ 'v3-dashboard-menu-whats-new' | translate }}</li>
                    @if (canAccessNotifications$ | async) {
                        <li role="none">
                            <a role="menuitem" (click)="close()" appListItem [routerLink]="['/notifications']" class="menu-item">
                                <app-icon class="tw-size-5" name="bell" />
                                <span class="menu-item-text">
                                    {{ 'v3-header-item-notifications' | translate }}
                                </span>
                                @if (notificationCount) {
                                    <span
                                        [ariaLabel]="
                                            notificationCount === 1
                                                ? ('v3-header-notification-badge' | translate)
                                                : ('v3-header-notifications-badge' | translate: { count: notificationCount })
                                        "
                                        class="menu-item-badge"
                                    >
                                        {{ notificationCount > 9 ? '9+' : notificationCount }}
                                    </span>
                                }
                            </a>
                        </li>
                    }
                    <li role="none">
                        <a role="menuitem" appListItem [href]="announcementsLink" target="_blank" class="menu-item" (click)="close()">
                            <app-icon class="tw-size-5" name="announcements-notes" />
                            <span class="menu-item-text">{{ 'v3-global-whats-new-announcements' | translate }}</span>
                        </a>
                    </li>
                </ul>

                <ul role="menu" [ariaLabel]="'v3-header-menu-title-settings' | translate">
                    <li role="none" class="section-header" aria-hidden="true">{{ 'v3-header-menu-title-settings' | translate }}</li>
                    @for (item of settingsItems$ | async; track item.name) {
                        <li role="none">
                            @switch (item.icon) {
                                @case ('logout') {
                                    <button
                                        role="menuitem"
                                        appListItem
                                        class="menu-item tw-w-full"
                                        (click)="logoutClick()"
                                        linkDataTest="logoutLink"
                                        (click)="close()"
                                    >
                                        <app-icon class="tw-size-5" [name]="item.icon" />
                                        <span class="menu-item-text">{{ item.name | translate }}</span>
                                    </button>
                                }

                                @default {
                                    <a role="menuitem" appListItem [routerLink]="item.route" class="menu-item" (click)="close()">
                                        <app-icon class="tw-size-5" [name]="item.icon" />
                                        <span class="menu-item-text">{{ item.name | translate }}</span>
                                    </a>
                                }
                            }
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
</div>

<ng-template #userInfo>
    <app-profile-avatar size="2md" />

    <div>
        <div class="tw-text-sm tw-font-bold">{{ user.firstname }} {{ user.surname }}</div>

        @if (hasTrial) {
            <div class="tw-text-xs">{{ user.company.name }}</div>
        }

        @if (!hasTrial && !hasSelfRegistration) {
            <div class="tw-text-xs">{{ user.department.name }}</div>
        }
    </div>
</ng-template>
